import { Card } from '../../../styles';
import { OptionType, SelectedPermissionType } from '../../../types';
import edit from '../../../../../../../assets/images/icons/edit.svg';
import add from '../../../../../../../assets/images/icons/plus.svg';
import download from '../../../../../../../assets/images/icons/downloadOrange.svg';
import trash from '../../../../../../../assets/images/icons/trash.svg';
import view from '../../../../../../../assets/images/icons/eyeGreen.svg';

interface IPagePermissionsCard {
  pageLabel: string;
  pageCode: number;
  permissions: SelectedPermissionType;
  handleOpenPageBeingSettedPermissionsModal: (page: OptionType) => void
}

export default function PagePermissionsCard({
  pageLabel,
  pageCode,
  permissions,
  handleOpenPageBeingSettedPermissionsModal,
}: IPagePermissionsCard) {
  const hasAnyPermission = !!(permissions.add || permissions.delete || permissions.download || permissions.update || permissions.view);
  return (
    <Card>
      <div className="info">
        <div className="card-title">
          <strong>{pageLabel}</strong>
          <small className="grayPermissions">
            {hasAnyPermission
              ? (
                <>
                  {permissions.view && (<img src={view} title='Visualizar' />)}
                  {permissions.add && (<img src={add} title='Adicionar' />)}
                  {permissions.update && (<img src={edit} title='Editar' />)}
                  {permissions.delete && (<img src={trash} title='Remover' />)}
                  {permissions.download && (<img src={download} title='Baixar Relatório' />)}
                </>
              )
              : ('Sem permissões')}
          </small>
        </div>
      </div>
      <div className="actions">
        <button
          type="button"
          onClick={() => {
            handleOpenPageBeingSettedPermissionsModal({ pageCode, pageLabel });
          }}
        >
          <img src={edit} alt="alterar" title="Alterar permissões da página" className="primaryColor" />
        </button>
      </div>
    </Card>
  );
}
